import React, { useState } from 'react';

import Container from '@mui/material/Container';
import Header from '../components/Header';
import Converter from '../components/Converter';
import Actions from '../components/Actions';

import { latinize } from '../util/latinize';

const saveCyrillic = (cyrillic) => {
  if (typeof window !== 'undefined' && typeof cyrillic === "string") {
    localStorage.setItem("cyrillic", cyrillic);
  }
}

const loadCyrillic = () => {
  const cyrillic = typeof window !== 'undefined' && localStorage.getItem("cyrillic");
  if (typeof cyrillic === "string") {
    return cyrillic;
  } else {
    return "";
  }
}

export default function Index() {
  const [cyrillicText, setCyrillicText] = useState(loadCyrillic());
  const [latinText, setLatinText] = useState(latinize(cyrillicText));

  const handleConverterChange = (cyrillic, latin) => {
    setCyrillicText(cyrillic);
    setLatinText(latin);
    saveCyrillic(cyrillic);
  }

  const handleOnClear = () => {
    setCyrillicText("");
    setLatinText("");
    saveCyrillic("");
  }

  const handleOnCopy = () => {
    navigator.clipboard.writeText(latinText);
  }

  return (
    <div>
      <Header />
      <Container maxWidth="lg" sx={{ marginTop: 2 }}>
        <Converter cyrillicText={cyrillicText} latinText={latinText} onChange={handleConverterChange} />
        <Actions onClear={handleOnClear} onCopy={handleOnCopy} />
      </Container>
    </div>
  );
}
